import React from 'react';

const LifePreserverFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M11.9 7.6c.7 0 1.3.2 1.9.4l4.1-4.1C16.3 2.7 14.2 2 12 2s-4.3.7-5.9 1.9l4 4c.6-.2 1.2-.3 1.8-.3zM11.9 16.4c-.7 0-1.3-.1-1.8-.4l-4 4c1.7 1.2 3.7 2 5.9 2s4.3-.7 5.9-2l-4-4c-.6.3-1.3.4-2 .4zM7.5 12c0-.7.2-1.4.5-2L4 6c-1.3 1.7-2 3.8-2 6s.7 4.3 1.9 5.9l4-4c-.3-.6-.4-1.2-.4-1.9zM20 6.1l-4.1 4.1c.3.6.4 1.2.4 1.8 0 .6-.1 1.3-.4 1.8l4.1 4.1c1.2-1.7 1.9-3.7 1.9-5.9.1-2.2-.6-4.3-1.9-5.9z" />
        </g>
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M4.694 19.872l-.707-.707 5.657-5.657.707.707zM9.69 10.352L4.033 4.696l.708-.707 5.656 5.656zM19.181 4.004l.707.707-5.656 5.657-.707-.708zM19.162 19.92l-5.656-5.658.707-.707 5.656 5.657z" />
        </g>
    </svg>
);

LifePreserverFillSvg.displayName = 'LifePreserverFillSvg';
export default LifePreserverFillSvg;
